import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    session: null,
    mapLoaded: false
  },
  getters: {
    getSession: state => {
        if(!state.session){
            return null;
        }
        return state.session;
    },
    getMapLoaded: state => {
        return state.mapLoaded;
    },
    
  },
  mutations: {
    setSession: (state, payload) =>{
      state.session = payload;
    },
    setSessionCulture: (state, payload) =>{
          state.session.culture = payload;
    },
    setLastBcTransactionID: (state, payload) =>{
          state.lastBcTransactionID = payload
    },
    setMapLoaded: (state) => {
        state.mapLoaded = true
    },
  },
  actions: {
    setSession: (context, payload) =>{
      context.commit('setSession', payload)
    },
    setSessionCulture: (context, payload) =>{
        context.commit('setSessionCulture', payload);
    },
    setLastBcTransactionID: (context, payload) =>{
        context.commit('setLastBcTransactionID', payload)
    },
    setMapLoaded: (context) => {
        context.commit('setMapLoaded')
    }
  }
})
